import { Permission } from '@Constants/Permission.g';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { getFrameLabel } from '@Constants/getFrameLabel';
import { useHasPermission } from '@Contexts/appContext';
import { ApiVat } from '@Model';
import {
    Card,
    EditFrameMode,
    EditFrameShell,
    FrameEditBase,
    Grid,
    GridColumns,
    IFrameBodyProps,
    IFrameEditShellProps,
    NumberInput,
    TextInput,
    useFrameEditBaseNavigation,
    useGuiBinder,
    useTranslate,
} from '@synqo/frontend-component-library';
import { useParams } from 'react-router';

export function FrameEditVat(props: IFrameEditShellProps<ApiVat>) {
    const hasPermission = useHasPermission();
    const { itemId } = useParams();
    const primaryKey = props.primaryKey ?? itemId ?? '';

    const frameEditBaseNavigationEvents = useFrameEditBaseNavigation();

    return (
        <FrameEditBase<ApiVat>
            apiResourcePath={`${STAMMDATEN_API}/vat`}
            renderer={FrameEditVatBody}
            key={primaryKey}
            primaryKey={primaryKey}
            embedded={props.embedded || props.primaryKey !== undefined}
            canEdit={props.canEdit !== false && hasPermission(Permission.StammdatenVatUpdate)}
            canCreate={props.canCreate !== false && hasPermission(Permission.StammdatenVatCreate)}
            canDelete={props.canDelete !== false && hasPermission(Permission.StammdatenVatDelete)}
            frameProps={{ events: { ...frameEditBaseNavigationEvents, ...props.events } }}
        />
    );
}

function FrameEditVatBody(props: IFrameBodyProps<ApiVat>) {
    const i18n = useTranslate('');

    const binder = useGuiBinder<ApiVat>({
        ...props,
        canEdit: props.mode !== EditFrameMode.View,
    });

    return (
        <EditFrameShell
            headerProps={{
                label: getFrameLabel('Mehrwertsteuer', props.mode),
                resourceLabel: 'Mehrwertsteuersatz',
                ...props.events,
            }}
            bannerProps={{
                mode: props.mode,
                loading: props.stateQueueDepth > 0,
                ...props.events,
            }}
        >
            <Card name="PrimaryVatData" border={'withoutBorder'}>
                <Grid>
                    <GridColumns spans={[6, 6, 6, 6, 12]}>
                        <TextInput {...binder.bindToProp<string>('shorthand')} label={i18n('Suchcode')} />
                        <TextInput {...binder.bindToProp<string>('label')} label={i18n('Bezeichnung')} />
                        <NumberInput {...binder.bindToProp<number>('rate')} label={i18n('Mehrwertsteuersatz in %')} />
                        <TextInput {...binder.bindToProp<string>('code')} label={i18n('Code')} />
                        <TextInput {...binder.bindToProp<string>('remarks')} inputSize={3} label={i18n('Bemerkung')} />
                    </GridColumns>
                </Grid>
            </Card>
        </EditFrameShell>
    );
}
